import { useInfiniteQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';
import { DEFAULT_PAGE_SIZE } from '@app-velocity/common';
import {
  PrototypeQueryOptions,
  buildPrototypeQueryParams,
} from '@app-velocity/libs/report';

export const useGetPrototypesInfiniteQuery = (
  workspaceId?: string,
  sourceId?: string | null,
  options?: PrototypeQueryOptions
) => {
  const { prototypes } = useAvApi();
  const pageSize = options?.size ?? DEFAULT_PAGE_SIZE;

  return useInfiniteQuery({
    enabled: !!workspaceId && (!!sourceId || sourceId === null),
    queryKey: [
      'workspace-prototypes-infinite',
      workspaceId,
      sourceId || '',
      options,
      pageSize,
    ],
    queryFn: async ({ pageParam = 0 }) => {
      if (!workspaceId) {
        return {
          content: [],
          totalElements: 0,
          totalPages: 0,
          number: 0,
          size: pageSize,
          last: true,
          first: true,
          empty: true,
        }
      }

      const response = await prototypes.getV2ProjectsPrototypesByProjectId(
        { projectId: workspaceId },
        buildPrototypeQueryParams(sourceId, {
          ...options,
          page: pageParam,
          size: pageSize,
        })
      );

      return response.data;
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage) =>
      lastPage.last ? undefined : (lastPage.number ?? 0) + 1,
    staleTime: 10000,
  });
};
